import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'
const UserManagerRouter: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "userManager" */'@/views/user-manager/login/Index.vue')
  },
  {
    path: '/set-password',
    name: 'SetPassword',
    component: () => import(/* webpackChunkName: "userManager" */'@/views/user-manager/password/SetPassword.vue')
  },
  {
    path: '/404',
    name: '404',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/404/Index.vue')
      }
    ]
  }
  // {
  //   path: '/changePassword',
  //   component: Layout,
  //   meta: {
  //     title: 'test',
  //     icon: '#iconexample',
  //     alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'changePassword',
  //       component: () => import(/* webpackChunkName: "menu-list" */ '@/views/user-manager/password/changePassword.vue'),
  //       name: 'changePassword',
  //       meta: {
  //         title: 'testList',
  //         icon: 'list'
  //       }
  //     }
  //   ]
  // }
]
export default UserManagerRouter
